import { apiClient } from '@/lib/apiClient';
import type { PaginadoResponse, HistoricoPrecoDto } from '../types';

const BASE = '/api/compras/historico-precos';

export const historicoPrecosService = {
  getAll: (params: { produtoId?: number; fornecedorId?: number; pagina?: number; tamanhoPagina?: number }) =>
    apiClient.get<PaginadoResponse<HistoricoPrecoDto>>(BASE, { params }).then(r => r.data),
};
